import React from 'react';
import Select from 'react-select';

const SelectorMultipleCorrespondecia = ({
  name,
  title,
  inputs,
  setInputs,
  data,
  selectDefault,
  url,
  disabled = false,
  onChange 
}) => {

  const fallbackOnChange = (selectedOptions) => {
    let selection = { ...inputs };
    selection[name] = selectedOptions ? selectedOptions.map(opt => ({
      name,
      value: opt.value,
      label: opt.label
    })) : [];
    setInputs(selection);
  };

  return (
    <div className="row">
      <div className="col-12">
        <Select
          defaultValue={selectDefault}
          isMulti
          name={name}
          options={data}
          className="basic-multi-select"
          classNamePrefix="select"
          value={inputs[name] || []}
          onChange={(selected) => {
            if (onChange) {
              onChange(selected || [], name);
            } else {
              fallbackOnChange(selected || []);
            }
          }}
          isDisabled={disabled}
        />
        <span>
          <b style={{fontSize: '11.5px', color: '#2b3361'}}>{title}</b>
        </span>
      </div>
    </div>
  );
};

export default SelectorMultipleCorrespondecia;